/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useEffect } from 'react';
import { Collapse } from '@mui/material';
import { EmbersDateCalendar } from '../dateCalendar';
import { EmbersDateRangeCalendar } from '../dateRangeCalendar';
import { convertToDate, focusToFirstActiveElement } from '../../utils/dateUtils';
export var EmbersDatePickerView = function EmbersDatePickerView(_ref) {
  var id = _ref.id,
    open = _ref.open,
    isRangeView = _ref.isRangeView,
    format = _ref.format,
    autoFocus = _ref.autoFocus,
    date = _ref.date,
    onPickerChange = _ref.onPickerChange,
    onRangePickerChange = _ref.onRangePickerChange,
    onRangePickerCancel = _ref.onRangePickerCancel,
    disableFuture = _ref.disableFuture,
    disablePast = _ref.disablePast;
  useEffect(function () {
    if (autoFocus) {
      focusToFirstActiveElement("#".concat(id));
    }
  }, [autoFocus]);
  return /*#__PURE__*/React.createElement(Collapse, {
    id: id,
    in: open,
    orientation: "horizontal",
    unmountOnExit: true
  }, !isRangeView ? /*#__PURE__*/React.createElement(EmbersDateCalendar, {
    format: format,
    hasInput: true,
    value: convertToDate(date),
    onPickChange: onPickerChange,
    disableFuture: disableFuture,
    disablePast: disablePast
  }) : /*#__PURE__*/React.createElement(EmbersDateRangeCalendar, {
    format: format,
    hasInput: true,
    value: date,
    withFooter: true,
    onCancel: onRangePickerCancel,
    onPickerChange: onRangePickerChange,
    disableFuture: disableFuture,
    disablePast: disablePast
  }));
};